<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="owner">
            <div class="row">
              <div class="col-md-12">
                <pr-input-column label="Résidence fiscale" [derrors]="derrors">
                  <pr-select-search
                    formControlName="taxResidence"
                    label="Résidence fiscale"
                    [options]="countries"
                  >
                  </pr-select-search>
                </pr-input-column>
              </div>
            </div>
            @if (hasSwisslifeProduct && isNotFranceTaxResidence(owner.value)) {
              <div class="row">
                <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
                  <pr-input-date
                    label="Date de cessation de la résidence fiscale en France"
                    formControlName="dateNonResidenceFiscaleEnFrance"
                    [derrors]="derrors"
                    [isDefault]="false"
                  ></pr-input-date>
                </div>
              </div>
            }
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
